import {makeBusinessEntity, PartialBusinessEntityOptions} from "../../../lib/libby/generator";
import { businessOptions } from "../businessOptions";

const DAO_NAME = 'seccion';

const defaultOptions: PartialBusinessEntityOptions<any> = {
  hoc: {
    withAccordionSelector: {
      idKey: 'idseccion',
      labelKey: 'nombre',
    },
    withSelectedChips: {
      idKey: 'idseccion',
      labelKey: 'nombre',
    },
  },
};

const optionsToUse = !businessOptions.Section ? defaultOptions : {
  ...defaultOptions,
  ...businessOptions.Section,
  hoc: { ...defaultOptions.hoc, ...businessOptions.Section.hoc }
};

const {
  hook: { fetchById, libbyCall, libbyDAO, libbyFetch },
  hoc: { entityAutocomplete, renderPropCall, renderPropFetchById, simpleSelect, accordionSelector, selectedChips },
  context: {
    byIdContext: { useByIdContext, ByIdProvider, ByIdContext },
    generalContext: { useGeneralContext, GeneralProvider, GeneralContext },
  },
} = makeBusinessEntity<any>(DAO_NAME, optionsToUse);

// hooks
export const useSectionFetchById = fetchById;
export const useSectionLibbyCall = libbyCall;
export const useSectionDAO = libbyDAO;
export const useSectionLibbyFetch = libbyFetch;

// components/hoc
export const SectionAutocomplete = entityAutocomplete;
export const SectionCall = renderPropCall;
export const SectionById = renderPropFetchById;
export const SectionSelect = simpleSelect;
export const SectionAccordionSelector = accordionSelector;
export const SectionSelectedChips = selectedChips;

// context
// ByIdContext
export const useSectionByIdContext = useByIdContext;
export const SectionByIdProvider = ByIdProvider;
export const SectionByIdContext = ByIdContext;
// GeneralContext
export const useSectionContext = useGeneralContext;
export const SectionProvider = GeneralProvider;
export const SectionContext = GeneralContext;
